export default {
  translation: {
    'shared.french': 'English',
    'app.name': 'Espace client Hellio Ingénierie',
    'auth.hero': 'Bienvenue sur\nvotre espace client Hellio ingénierie',
    'auth.hero_partner':
      'Bienvenue sur votre espace partenaire Hellio ingénierie',
  },
  global: {
    'Internal server error':
      "Une erreur inattendue s'est produite. Veuillez réessayer plus tard.",
    hero: 'Bienvenue sur votre espace client',
    hero_partner: "L'énergie au coeur de votre projet",
    password: 'Mot de passe',
    email: 'E-mail',
    logout: 'Se déconnecter',
    question: 'Une question ?',
    cancel: 'Annuler',
    close: 'Fermer',
    back: 'Retour',
    yes: 'Oui',
    no: 'Non',
    apply: 'Appliquer',
    reset: 'Réinitialiser',
    more: 'Afficher plus',
    less: 'Afficher moins',
    validate: 'Valider',
    required: 'Ce champ est obligatoire',
    rdv: 'Prendre rendez-vous',
    max_file: 'Le fichier ne doit pas dépasser {{size}}Mo.',
    internet_connexion_error:
      "Une erreur inattendue s'est produite. Veuillez réessayer plus tard.",
    scenario_selected: 'Scénario sélectionné avec succès.',
    'email.required': 'Veuillez renseigner une adresse e-mail valide',
    session_expired: 'Votre session a expiré. Veuillez vous reconnecter.',
    files_uploaded_one: 'Fichier envoyé avec succès',
    files_uploaded_other: 'Fichiers envoyés avec succès',
    download_error:
      'Une erreur est survenue lors du téléchargement du fichier.',
    upload_error: "Erreur lors de l'envoi du fichier",
    devis_uploaded_for: 'devis envoyé pour',
    travaux: 'travaux',
  },
  filesize: {
    symbols: {
      iec: {
        bytes: {
          B: 'o',
          KiB: 'Kio',
          MiB: 'Mio',
          GiB: 'Gio',
          TiB: 'Tio',
          PiB: 'Pio',
          EiB: 'Eio',
          ZiB: 'Zio',
          YiB: 'Yio',
        },
      },
      jedec: {
        bytes: {
          B: 'o',
          KB: 'Ko',
          MB: 'Mo',
          GB: 'Go',
          TB: 'To',
          PB: 'Po',
          EB: 'Eo',
          ZB: 'Zo',
          YB: 'Yo',
        },
      },
    },
  },
  login: {
    hero: 'Connexion',
    description: 'Renseignez votre adresse email et votre mot de passe',
    forgot: 'Mot de passe oublié',
    login_error: 'Votre identifiant ou votre mot de passe est incorrect',
    submit: 'Se connecter',
    impersonate:
      'Vous êtes connecté en tant que <strong>{{firstname}} {{lastname}}</strong>',
  },
  first_login: {
    hero: 'Première connexion',
    description: 'Renseignez votre mot de passe',
    success: 'La création de votre mot de passe a bien été prise en compte.',
    error: "Votre lien à expiré ou n'est plus valide",
    success_description: 'Création de votre mot de passe',
    success_action: 'Se connecter',
    submit: 'Valider',
    password: 'Mot de passe',
    same: 'Les mots de passes ne sont pas identiques',
    'confirm.password': 'Confirmer mot de passe',
    'confirm.regex.error':
      'Le mot de passe doit contenir 8 caractères :\nune majuscule, un chiffre et un caractère spécial.',
    'confirm.placeholder.password': 'Confirmation du mot de passe',
  },
  change_password: {
    hero: 'Réinitialisation de mot de passe',
    description: 'Veuillez renseigner votre nouveau mot de passe',
    submit: 'Valider',
    success: 'Modification du mot de passe',
    success_description: 'Votre mot de passe a bien été réinitialisé',
    success_action: 'Se connecter',
    password: 'Nouveau mot de passe',
    same: 'Les mots de passes ne sont pas identiques',
    'confirm.password': 'Confirmer mot de passe',
    'confirm.regex.error':
      'Le mot de passe doit contenir 8 caractères :\nune majuscule, un chiffre et un caractère spécial.',
    'confirm.placeholder.password': 'Confirmation du mot de passe',
  },
  404: {
    hero: 'Page introuvable',
    description: "La page que vous cherchez n'existe pas ou a été déplacée.",
    back: "Retour à l'accueil",
  },
  reset_password: {
    hero: 'Mot de passe oublié',
    description:
      'Veuillez saisir votre email de connexion afin de recevoir le lien de réinitialisation de votre mot de passe.',
    submit: 'Valider',
    error: "Votre lien à expiré ou n'est plus valide",
    back: 'Retour',
    success: 'Réinitialisation du mot de passe',
    success_alert:
      "Nous vous avons envoyé un e-mail pour réinitialiser votre mot de passe. Pour créer votre nouveau mot de passe, il vous suffit de cliquer sur le lien contenu dans l'e-mail et d'en saisir un nouveau.",
    success_description:
      "<strong>Vous n'avez pas reçu cet e-mail</strong><br> Vérifiez vos courriers indésirables ou contactez :<br>",
  },
  select: {
    all: 'Tout sélectionner',
    none: 'Tout désélectionner',
  },
  file: {
    default_label: 'Fichiers',
    delete: 'Supprimer le fichier {{file}}',
    default_drop_zone_label_one: 'Veuillez charger votre fichier ici',
    default_drop_zone_label_other: 'Veuillez charger vos fichiers ici',
    or: 'ou',
    browse: 'Parcourir...',
    supported_types:
      'Taille maximale : 20 Mo. Formats supportés : jpg, png, pdf, doc, docx, xls, xlsx, ppt, pptx. 10 fichiers max.',
    max_size: 'Max',
    max_size_info:
      'Taille maximale : {{size}} Mo. Formats supportés : jpg, png, pdf. Un seul fichier possible.',
    max_files_other: '{{count}} fichiers maximum',
    max_files_one: 'Un fichier maximum',
    max_files_zero: 'Aucun fichier restant',
    max_error_files: 'Vous ne pouvez pas envoyer plus de {{maxFiles}} fichiers',

    named_max_error_size_one: 'Le fichier: {{name}}, dépasse 10Mo',
    named_max_error_size_other: 'Les fichiers: {{name}}, dépassent 10Mo',
    size_error_message_one:
      "Le fichier {{fileNames}} n'a pas pu être importé correctement (> {{maxSize}} Mo)",
    size_error_message_other:
      "Les fichiers {{fileNames}} n'ont pas pu être importés correctement (> {{maxSize}} Mo)",
    preview_not_available: "L'aperçu n'est pas disponible",
    preview_not_supported:
      "L'aperçu des fichiers {{type}} n'est pas pris en charge",
  },
  profil: {
    title: 'Mes identifiants',
    subtitle: 'Veuillez renseigner votre nouveau mot de passe',
    identity: 'Identité',
    firstname: 'Prénom',
    mobilephone: 'Téléphone mobile',
    lastname: 'Nom',
    email: 'E-mail',
    update_password: 'Modifier mot de passe',
    oldPassword: 'Ancien mot de passe',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le nouveau mot de passe',
    validate: 'Valider',
    cancel: 'Annuler',
    change_password_success_title: 'Nouveau mot de passe bien enregistré',
    change_password_success_subtitle:
      'Votre changement de mot de passe a bien été pris en compte',
    mentions_legals: 'Mentions légales',
    mentions_legals_link:
      'https://www.hellio.com/mentions-legales?_gl=1*qgr4eo*_gcl_au*MTE3MzQ3Mzg3NS4xNzUwMDg1OTYzLjQ3ODA5NzQxMy4xNzUwMjUzNzY2LjE3NTAyNTM3NjY',
    CGV: 'CGV',
    CGV_link:
      'https://www.hellio.com/hubfs/CONDITIONS%20G%C3%89N%C3%89RALES%20DE%20VENTE%20(CGV)%20-%20HI.pdf?_gl=1*1d8both*_gcl_au*MTE3MzQ3Mzg3NS4xNzUwMDg1OTYzLjQ3ODA5NzQxMy4xNzUwMjUzNzY2LjE3NTAyNTM3NjY',
    privacy: 'Politique de confidentialité',
    privacy_link:
      'https://www.hellio.com/hubfs/Politique%20de%20confidentialit%C3%A9%20%E2%80%93%20Hellio%20Ing%C3%A9nierie.pdf?_gl=1*xb8v8g*_gcl_au*MTE3MzQ3Mzg3NS4xNzUwMDg1OTYzLjQ3ODA5NzQxMy4xNzUwMjUzNzY2LjE3NTAyNTM3NjY',
  },
  ressources: {
    title: 'Mes ressources',
    intro:
      'Télécharger ou visualiser notre collection de documents spécialisés et conçus pour vous aider à comprendre tous les aspects de la rénovation énergétique d’un bien.',
  },
  project: {
    travaux: 'Travaux',
    details: 'Voir projet',
    owner: 'Mon interlocuteur',
    build_date: 'Année de construction',
    surface: 'Surface',
    meters: 'm²',
    badge_power: 'Étiquette énergétique',
    project: 'Projet',
    documents: 'Documents',
    my_project: 'Mon logement',
    my_documents: 'Mes documents',
    my_mar: "Mon Accompagnateur Rénov'",
    my_interlocutors: 'Mes interlocuteurs',
    my_commercial: 'Mon commercial',
    my_admin_helper: 'Mon Assistante Administrative',
    house: 'Logement',
    build_year: 'Année de construction',
    scenario: 'Scénario retenu',
    budget: 'Coût du projet',
    amount: 'Montant des travaux',
    mpra_help: 'Aides MaPrimeRénov’',
    rest: 'Reste à charge',
    power_class: 'Classe énergétique',
    power_class_before: 'Avant projet',
    power_class_after: 'Après projet',
    power_class_gap_other: 'Saut de {{count}} classes énergétiques',
    power_class_gap_one: 'Saut d’une classe énergétique',
    power_class_gap_zero: 'Pas de changement de classe énergétique',
    fiscal_house: 'Foyer',
    fiscal_salary: 'Revenu fiscal',
    mpra: 'MaPrimeRénov’',
    status: {
      available: 'Disponible',
      signed: 'Signé',
      to_plan: 'À planifier',
      in_progress: 'En rédaction',
      planned: 'Planifiée au {{date}}',
      at: 'Le ',
      work_end: 'Fin des travaux prévue le {{date}}',
    },
    status_type: {
      visit_1_mar: 'Date de la visite 1 MAR',
      final_visit: 'Date visite finale',
      work_end: 'Date prévisionnelle de fin de chantier',
    },
    files_to_drop_one: 'Un document à déposer',
    files_to_drop_other: '{{count}} documents à déposer',
    to_drop_tooltip: 'Vous avez des documents à déposer',
    scenario_tag: {
      title: 'Scénario de travaux',
      to_define: 'À définir',
      validated: 'Scénario validé',
      progress: 'En cours de traitement',
    },
    scenario_selection: {
      modal_title: 'Choisir le scénario de travaux',
      modal_description:
        "Nous vous proposons des scénarios selon vos besoins et l'étiquette énergétique visée, définissant la liste de travaux à réaliser.",
      card_description:
        "Pour définir votre étiquette énergétique d'arrivée, vous devez choisir votre scénario.",
      current_class: 'Classe actuelle',
      select_scenario: 'Sélectionner ce scénario',
      selected_scenario: 'Scénario sélectionné',
      view_audit_details: "Voir le détail des scénarios sur l'audit",
      no_scenarios: 'Aucun scénario disponible',
      choose_scenario: 'Choisir le scénario',
      engagement_title:
        'Vous vous engagez à nous transmettre des devis travaux conformes à celui-ci.',
      engagement_description:
        'Le choix du scénario est définitif. Une fois confirmé, vous ne pourrez plus le modifier.',
      cancel: 'Annuler',
      confirm: 'Confirmer ce scénario',
      question_text: 'Une question sur vos scénarios de travaux ?',
      take_meeting: 'Prendre rendez-vous',
      your_selection: 'Votre sélection',
      renovation_once: 'Rénovation en une fois',
      renovation_step: 'Rénovation par étape',
      scenario_number: 'Scénario {{number}}',
      success_title: 'Scénario sélectionné avec succès',
      success_description:
        'Votre scénario sera bientôt mis à jour après confirmation par notre équipe.',
      back_to_project: 'Revenir à mon projet',
    },
    devis_to_deposit_one: 'Un devis à déposer',
    devis_to_deposit_other: '{{count}} devis à déposer',
    travaux_status: {
      devis_to_deposit_one: 'Un devis à déposer',
      devis_to_deposit_other: '{{count}} devis à déposer',
      devis_non_conforme_one: 'Un devis non conforme',
      devis_non_conforme_other: '{{count}} devis non conformes',
      devis_en_analyse: "En cours d'analyse",
      devis_conformes: 'Devis conformes',
    },
  },
  travaux: {
    title: 'Travaux',
    devis_deposes: 'Devis déposés',
    devis_conformes: 'Devis conformes',
    add_devis: 'Ajouter un devis',
    correct_devis: 'Corriger le devis',
    add_devis_multiple: 'Ajouter un devis à plusieurs travaux',
    select_travaux_concerned: 'Sélectionnez les travaux concernés',
    travaux_selected_zero: 'Aucun travaux associés à mon devis',
    travaux_selected_one: 'Un travail associé à mon devis',
    travaux_selected_other: '{{count}} travaux associés à mon devis',
    deposit_devis_associated: 'Déposer le devis associé à mes travaux',
    add_devis_button: 'Ajouter le devis',
    file_too_large: 'Fichier trop volumineux',
    cancel: 'Annuler',
    validation: {
      error_title: 'Erreurs de validation',
      select_at_least_one_travaux: 'Veuillez sélectionner au moins un travaux',
      select_compatible_file: 'Veuillez choisir un fichier compatible',
      fix_file_error: 'Veuillez corriger les erreurs du fichier',
    },
    status: {
      to_deposit: 'À déposer',
      analyse_en_cours: 'Analyse en cours',
      conforme: 'Conforme',
      non_conforme: 'Non conforme',
    },
    alert: {
      all_devis_required:
        'Le traitement du dossier ne peut commencer que si tous les devis sont déposés',
    },
  },
  documents: {
    upload: 'Importer un fichier',
    title: 'Documents',
    file: 'Fichier',
    file_type: 'Type de fichier',
    actions: 'Actions',
    by_hellio: 'Déposé par Hellio Ingénierie le {{date}}',
    by_me: 'Déposé par moi le {{date}}',
    download: 'Télécharger le fichier',
    update: 'Mettre à jour le fichier',
    empty: "Aucun document n'a été déposé",
    import: 'Import de fichier [{{category}}]',
    hint: "Vous avez la possibilité d'importer jusqu'à {{length}} documents par catégories de fichier de {{size}}Mo.",
    to_drop: 'À déposer',
  },
  pdf_viewer: {
    missing_url: 'URL du PDF manquante',
    page_of: 'Page {{current}} sur {{total}}',
    loading: 'Chargement...',
    error_loading: 'Erreur lors du chargement du PDF',
  },
  document_modal: {
    placeholder: 'Sélectionner',
    title: 'Importer un fichier',
    description:
      'Veuillez déposer votre document qui sera étudié par votre Accompagnateur Rénov’.',
    category: 'Type de document',
  },
  documents_categories: {
    all: 'Tous les documents',
    devis: 'Devis',
    devis_hellio_inge: 'Devis Hellio Ingénierie',
    preuve_virement: 'Preuve de virement',
    attestation_travaux: 'Attestations',
    piece_administratives: 'Pièces administratives',
    restitution_audit: 'Audit énergétique',
    devis_travaux: 'Devis travaux',
    grille_analyse_logement: "Grille d'analyse du logement",
    plan_financement: 'Plan de financement',
    factures: 'Factures',
    rapport_accompagnement: "Rapport d'accompagnement",
  },
  documents_category: {
    avis_d_imposition__1_: 'Avis d’imposition',
    avis_d_imposition: 'Avis d’imposition',
    fichier_dpe: 'DPE',
    audit_energetique: 'Audit énergétique existant',
    audit_energetique_final: 'Audit énergétique Hellio ingénierie',
    plan_de_financement___rapport_mar: 'Plan de financement final',
    plan_de_financement_previsionnel: 'Bilan financier',
    factures_hi: 'Factures',
    rapport_d_accompagnement__cerfa_anah_: "Rapport d'accompagnement",
    attestation_travaux__devis_: 'Attestation travaux',
    attestation_cee: 'Attestation CEE',
    rib_hi: 'RIB',
    grille_d_analyse_synthese: "Grille d'analyse du logement",
    fichier_devis: 'Devis travaux',
    fichier_devis__1_: 'Devis travaux',
    devis_mar_signe: 'Devis MAR',
    plans: 'Plan de configuration du bien',
    attestation_sur_l_honneur__proprietaire_bailleurs_:
      "Attestation sur l'honneur",
    justificatif_de_propriete: 'Titre de propriété',
    avis_de_virement_hi: 'Preuve de virement',
    attestation_travaux__facture_: 'Attestation travaux',
  },
  avatar: {
    avatar_change_success: 'Votre avatar a bien été modifié',
  },
  meeting: {
    cancelled: 'Reunion annulée avec succès',
    title: 'Mon rendez-vous',
    phone_description: 'Le rendez-vous se fera par téléphone.',
    place_description: 'Le rendez-vous se fera sur place',
    video_description: 'Le rendez-vous se fera en visioconférence',
    phone_title: 'Par téléphone',
    place_title: 'Sur place',
    video_title: 'En visioconférence',
    take: 'Prendre rendez-vous',
    cancel: 'Annuler',
    cancel_title: 'Annulation du rendez-vous',
    cancel_description: 'Souhaitez-vous vraiment annuler ce rendez-vous ?',
    reschedule: 'Replannifier',
  },
  steppers: {
    title: 'Suivez votre projet',
    show_all: 'Voir détails',
    hide_all: 'Masquer les détails',
  },
  resend_link_first_login: {
    title: 'Votre lien de connexion a expiré',
    action: 'Recevoir un nouveau lien',
    description:
      'Votre lien de connexion a expiré. Pour des raisons de sécurité, les liens de connexion sont valables uniquement pendant une durée limitée.',
    success_title: 'Votre lien de connexion a été envoyé par mail',
    success_description:
      "<strong>Vous n'avez pas reçu cet e-mail</strong><br> Vérifiez vos courriers indésirables ou contactez :<br>",
  },
  notifications: {
    title: 'Notifications',
    new: 'Nouvelle notification',
    empty: 'Vous n’avez pas de notification',
    enable_info:
      'Activez les notifications pour être alerté même lorsque la plateforme est fermée.',
    enable_action: 'Activer',
    enable_settings:
      'Notifications bloquées : activez-les dans les paramètres de votre navigateur.',
    enable_settings_google:
      'Votre navigateur bloque les notifications. Activez l’envoi des notifications Google dans ses paramètres.',
    DEPOTS_PIECES_ADMINISTRATIVES_title:
      "Veuillez déposer vos pièces administratives pour continuer le traitement de votre dossier (avis d'impositions, DPE si existant, preuve de virement de l'acompte)",
    DEPOSER_DEVIS_title:
      "N'oubliez pas de déposer vos devis pour continuer le traitement de votre dossier.",
    RAPPELER_RDV_title: 'Rappel : Votre rendez-vous est prévu pour demain.',
    PLANIFIER_RDV_title:
      "Planifiez un rendez-vous téléphonique avec votre Accompagnateur.trice Rénov' pour cadrer la visite.",
    AIDE_CONFIRME_PAR_MPR_title:
      "Félicitations ! Votre aide a été confirmée par MaPrimeRénov'",
    DOSSIER_DEMANDE_DE_SOLDE_TRANSMIT_title:
      'Votre dossier de demande de solde a été transmis avec succès. Nous attendons maintenant la validation de l’ANAH. Merci pour votre engagement !',
    PLANIFIER_RDV_DEPOT_FINAL_DDS_title:
      'Il est temps de planifier votre rendez-vous pour le dépôt final de votre demande de solde.',
    DEPOSER_VOS_FACTURES_CORRIGEES_title:
      'Déposez vos factures corrigées pour validation.',
    DEPOSER_VOS_FACTURES_TRAVAUX_title:
      'Votre projet passe une nouvelle étape. On approche de la fin ! Vous pouvez maintenant déposer vos factures de travaux.',
    CONFIRMATION_SELECTION_SCENARIO_title:
      "Félicitations ! Vous avez sélectionné votre scénario. Vous pouvez maintenant passer à l'étape suivante",
    PRENDRE_CONNAISSANCE_AUDIT_title:
      'Votre Audit est terminé et disponible, prenez-en connaissance dès maintenant !',
    RENSEIGNER_SCENARIO_TRAVAUX_title:
      'Renseignez dès maintenant votre choix de scénario de travaux et avancez dans votre projet de rénovation.',
    DEVIS_EN_COURS_D_ANALAYSE_title:
      "L'analyse de vos devis est en cours de traitement",
    DEVIS_NON_CONFORME_title:
      "Vous avez reçu un mail de votre Accompagnateur Rénov', qui vous précise les éléments de non-conformités de votre ou vos devis.",
    DEVIS_NON_CONFORME_RELANCE_title:
      "N'oubliez pas de nous redéposer votre ou vos devis conforme(s).",
  },
  pagination: {
    paginate: '{{from}} - {{to}} sur {{total}}',
  },
  clients: {
    title: 'Portefeuille de clients',
    filter: 'Filtres',
    select_all: 'Tout sélectionner',
    download: 'Télécharger',
    download_selection: 'Télécharger ({{count}})',
    export_filename: 'clients.csv',
    deselect_all: 'Tout désélectionner',
    search_placeholder: 'Rechercher un client, des coordonnées...',
    client: 'Client',
    travaux: 'Travaux',
    adresse: 'Adresse',
    ville: 'Ville',
    code_postal: 'Code postal',
    status: 'Statut',
    close: 'Fermer',
    select_all_alert_0:
      '<span class="font-light">Les</span> <strong class="font-semibold">{{count}} clients</strong> <span class="font-light">de cette page sont sélectionnées.</span>',
    select_all_alert_1: 'Sélectionner les {{count}} autres clients',
    select_all_alert_all_selected:
      'La totalité des {{count}} clients trouvés a été sélectionnée.',
    filter_search: 'Rechercher un type de travaux ou statut..',
    travaux_type: 'Type de travaux',
    project_status: 'Statut du projet',
  },
};
